// extracted by mini-css-extract-plugin
export var actionsRow = "_12-a";
export var actionsRowEnd = "_12-b";
export var askRedoBlackBtn = "_12-d";
export var askRedoBlackBtnIcon = "_12-e";
export var exitModalActionBtn = "_12-c";
export var exitModalRoot = "_12-0";
export var followUpInput = "_12-9";
export var modalContentBody = "_12-7";
export var modalHeaderImage = "_12-2";
export var modalImageLabel = "_12-4";
export var modalImageOverlay = "_12-3";
export var modalImageSubheading = "_12-6";
export var modalImageTitle = "_12-5";
export var modalImageWrapper = "_12-1";
export var reasonCard = "_12-f";
export var reasonCardSelected = "_12-g";
export var reasonIcon = "_12-j";
export var reasonIconWrap = "_12-i";
export var reasonIndicator = "_12-l";
export var reasonIndicatorDot = "_12-n";
export var reasonIndicatorSelected = "_12-m";
export var reasonLabel = "_12-h";
export var reasonList = "_12-8";
export var reasonTitle = "_12-k";